<template>
  <div>
    <SectionOne ref="viewOne" v-if="current===0" :projectId="projectId" />
    <SectionTwo ref="viewTwo" v-if="current===1" :projectId="projectId" />
    <SectionThree ref="viewThree" v-if="current===2" :projectId="projectId" />
    <div class="action-container action-container__bottom">
      <a-button :disabled="current<=0" @click="previousSection" class="action-btn first-action-btn">
        上一部分
      </a-button>
      <a-button :disabled="current>=2" @click="nextSection" class="action-btn" >
        下一部分
      </a-button>
      <div v-if="canAudit" class="audit-btn-container">
        <a-button  type="primary" class="action-btn" @click="onPass">
          通过
        </a-button>
        <a-button  type="danger" class="action-btn" @click="onReject">
          驳回
        </a-button>
        <a-input  placeholder="请输入复核意见" v-model="auditOpinion" style="width:300px"/>
      </div>
      <span v-else>状态：{{ sectionState }}</span>
    </div>

    <a-modal
        title="选择风险评估审核人"
        :visible="setRiskReviewerModalVisible"
        okText="确定"
        cancelText="取消"
        @ok="onConfirmRiskReviewer"
        @cancel="setRiskReviewerModalVisible=false"
    >
      <div class="field-container">
        <div class="field-label">风险评估人</div>
        <div>
          <a-select
              placeholder="请选择"
              mode="single"
              v-model="riskReviewerId"
              class="field-input"
          >
            <a-select-option v-for="reviewer in riskReviewers" :key="reviewer.userId" :value="reviewer.userId">
              {{ reviewer.realName }}
            </a-select-option>
          </a-select>
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
import BreadcrumbItem from "@/components/BreadcrumbItem.vue";
import {baseURL} from "@/services/HttpService";
import {auditProject, loadProjectStates} from "@/services/DocService";
import SectionOne from "@/views/SectionOne.vue";
import SectionTwo from "@/views/SectionTwo.vue";
import SectionThree from "@/views/SectionThree.vue";
import {loadProjectAuditorConfig, loadProjectRiskReviewerConfig} from "@/services/TeamMemberService";

export default {
  components: {SectionThree, SectionTwo, SectionOne, BreadcrumbItem, Breadcrumb },
  data() {
    return {
      projectId: "",
      current: 0,
      headers: {
        authorization: 'authorization-text',
      },
      viewUrl: baseURL + "/attachment?fileName=",
      projectStates: {
        state: "未提交",
        rationaleState: "未提交",
        internalState: "未提交"
      },
      auditOpinion: "",
      invoiceRatio:"",
      roi:"",
      riskReviewers: [],
      setRiskReviewerModalVisible: false,
      riskReviewerId: "",
    };
  },
  computed: {
    sectionState() {
      if(this.current===0) {
        return this.projectStates.state;
      } else if (this.current===1){
        return this.projectStates.rationaleState;
      } else if (this.current===2) {
        return this.projectStates.internalState;
      }
      return "";
    },
    canAudit() {
      console.log('canAudit',this.current);
      if (this.current===0) {
        console.log('section one state', this.projectStates.state);
        return this.projectStates.state === "已提交";
      } else if (this.current===1) {
        console.log('section two state', this.projectStates.rationaleState);
        return this.projectStates.rationaleState === "已提交";
      } else if (this.current===2) {
        console.log('section three state', this.projectStates.internalState);
        return this.projectStates.internalState === "已提交";
      }
    },
  },
  created() {
    this.projectId = this.$route.params.id;
    if(this.projectId && this.projectId !== "0") {
      this.startLoadProjectStatus();
    }
    console.log('projectId', this.projectId);
  },
  methods: {
    startLoadProjectStatus() {
      loadProjectStates(this.projectId).then(resp => {
        if (resp.data.code === "SUCCESS") {
          this.projectStates = resp.data.data;
        }
      });
    },
    onPass() {
      let companyId = "";
      if(this.current===0) {
        companyId = this.$refs.viewOne.getCompanyId();
        this.startLoadRiskReviewers(companyId);
      } else if (this.current===1) {
        companyId = this.$refs.viewTwo.getCompanyId();
        this.startLoadRiskReviewers(companyId);
      } else {
        let params = {
          projectId: this.projectId,
          pass: true,
          sectionNo: this.current,
          remark: this.auditOpinion
        }
        this.audit(params);
      }
    },
    onConfirmRiskReviewer(){
      if(this.riskReviewerId) {
        this.setRiskReviewerModalVisible = false;
        let params = {
          projectId: this.projectId,
          pass: true,
          sectionNo: this.current,
          remark: this.auditOpinion,
          riskReviewerId: this.riskReviewerId
        }
        this.audit(params);
      } else {
        this.$message.error("请选择风险评估人员");
      }
    },
    startLoadRiskReviewers(companyId){
      if(this.riskReviewers===undefined || this.riskReviewers.length===0) {
        loadProjectRiskReviewerConfig(this.projectId, companyId).then(resp => {
          if (resp.data.code === "SUCCESS") {
            this.riskReviewers = resp.data.data.riskReviewers;
            this.riskReviewerId = resp.data.data.riskReviewerId;
            this.setRiskReviewerModalVisible = true;
            if(this.riskReviewers && this.riskReviewers.length===0) {
              this.$message.error("没有可选风险评估审核人员，请先到项目公司板块配置");
            }
          }
        });
      } else {
        this.setRiskReviewerModalVisible = true;
      }
    },
    onReject() {
      let params = {
        projectId: this.projectId,
        pass: false,
        sectionNo: this.current,
        remark: this.auditOpinion
      }
      this.audit(params);
    },
    audit(params) {
      auditProject(params).then(resp => {
        if (resp.data.code === "SUCCESS") {
          this.$message.success("操作成功");
          this.auditOpinion = "";
          this.startLoadProjectStatus();
        } else {
          this.$message.error("操作失败:" + resp.data.errorMsg);
        }
      });
    },
    previousSection() {
      if(this.current > 0){
        this.current--;
      }
    },
    nextSection() {
      if(this.current < 3) {
        this.current = this.current + 1;
      }
    },

  }
}
</script>
<style scoped>
.audit-btn-container {
  width: auto;
  display: flex;
  align-items: center;
}
.field-container {
  display: flex;
  align-items: center;
}
.field-label {
  min-width: 100px;
}
.field-input {
  min-width: 220px;
}
</style>
